module.exports = __webpack_public_path__ + "SamsungOne-200C.4ee078cc2cb344a2e2a5.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-200C.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-200C.ttf
// module chunks = styles